import { useEffect, useMemo, useRef, useState } from 'react';
import { useLazyGetPaymentsV2Query } from '@ibk/pagamentos';
import { useSelectedAccount } from '@ibk/shared-auth';
import { useInstructionsPermissioning } from '@ibk/shared-permissioning';
import { localStorageService, StorageKeys } from '@ibk/shared-utils';
export const useAppHome = () => {
    const { selectedAccount } = useSelectedAccount();
    const [getPaymentsV2, { data: paymentsData, isLoading, isError }] = useLazyGetPaymentsV2Query();
    const [paymentsCount, setPaymentsCount] = useState(0);
    const hasFetchedRef = useRef(false);
    const { canApprovePaymentLinks, showApprovePaymentLinks } = useInstructionsPermissioning();
    const hasApprovalPermissions = useMemo(() => canApprovePaymentLinks && showApprovePaymentLinks, [canApprovePaymentLinks, showApprovePaymentLinks]);
    useEffect(() => {
        hasFetchedRef.current = false;
    }, [selectedAccount?.targetId, hasApprovalPermissions]);
    useEffect(() => {
        const loadInitialCount = async () => {
            if (!selectedAccount?.targetId) {
                return;
            }
            const storedTotal = await localStorageService.getItem(StorageKeys.PendingPaymentsTotal);
            if (typeof storedTotal === 'number') {
                setPaymentsCount(storedTotal);
            }
            else {
                setPaymentsCount(0);
            }
        };
        loadInitialCount();
    }, [selectedAccount?.targetId]);
    useEffect(() => {
        const fetchPayments = async () => {
            if (!selectedAccount?.targetId) {
                return;
            }
            if (hasApprovalPermissions === undefined) {
                return;
            }
            if (hasFetchedRef.current) {
                return;
            }
            hasFetchedRef.current = true;
            const status = hasApprovalPermissions ? 'AWAITING_MY_APPROVAL' : 'AWAITING_APPROVAL';
            try {
                const result = await getPaymentsV2({
                    approvalState: 'PENDING',
                    status,
                    pageSize: 10,
                    partyId: selectedAccount.targetId,
                }).unwrap();
                if (result?.result) {
                    const total = result.result.pagination?.total ?? 0;
                    await localStorageService.setItem(StorageKeys.PendingPaymentsList, result.result.data);
                    await localStorageService.setItem(StorageKeys.PendingPaymentsTotal, total);
                    setPaymentsCount(total);
                }
            }
            catch (error) {
                console.error('Error fetching payments:', error);
                setPaymentsCount(0);
            }
        };
        fetchPayments();
    }, [selectedAccount?.targetId, hasApprovalPermissions, getPaymentsV2]);
    return {
        paymentsData,
        isLoading,
        isError,
        hasApprovalPermissions,
        paymentsCount,
    };
};
